// React 端訂閱多螢幕狀態（LIVE-10）。
import { useEffect, useSyncExternalStore } from 'react';
import { multiScreen } from './multiScreen';
import { session } from './session';
import { markActivity } from '../features/live/relayGuard';
import { noteActivity } from './session';

/** 狀態版本號：peer 來去、警報視窗宣告時 +1，讓用到的元件重算。 */
let version = 0;
multiScreen.subscribe(() => {
  version++;
});

export function useMultiScreenVersion(): number {
  return useSyncExternalStore(
    (f) => multiScreen.subscribe(f),
    () => version,
  );
}

/** 這個視窗是不是警報視窗。 */
export function useIsAlarmWindow(): boolean {
  useMultiScreenVersion();
  return multiScreen.isAlarmWindow();
}

/** App 一進來掛一次：開頻道、同步登入登出與操作活動。 */
export function useMultiScreenSync(): void {
  useEffect(() => {
    multiScreen.start();
    let had = !!session.get();
    const unsub = session.subscribe((s) => {
      const has = !!s;
      if (had && !has) multiScreen.post({ t: 'logout' });
      if (!had && has) multiScreen.post({ t: 'login' });
      had = has;
    });
    const off = multiScreen.on((m) => {
      if (m.t === 'logout' && session.get()) location.reload(); // cookie 已清：重新整理就回登入頁
      const publicPage = location.pathname.startsWith('/share/') || location.pathname === '/verify';
      if (m.t === 'login' && !session.get() && !publicPage) location.reload(); // 另一個視窗登入了：用同一個 cookie 換 token（公開頁不動）
      if (m.t === 'activity') {
        noteActivity(m.at);
        markActivity(m.at);
      }
    });
    return () => {
      unsub();
      off();
    };
  }, []);
}
